import React from 'react'
import { TitleAniLeft } from '../../component/ScrollTest';
import { useLanguage } from '../../i18n/LanguageContext'

const COPY = {
  ja: {
    label: 'メール：',
  },
  zh: {
    label: '信箱：',
  },
}

export default function Footer() {
    const email = 'sally81506@gmail.com'; // 要預設的電子郵件地址
    const { lang } = useLanguage()
    const t = COPY[lang]

    const handleEmailClick = () => {
      window.location.href = `mailto:${email}`;
    };
  return (
    <div className='pFooter' id='contact'>
      <TitleAniLeft title='contact' title2='me'/>
      <div className='mailCon'>
          <p className='mail'>{t.label}<span onClick={handleEmailClick}>{email}</span></p>
      </div>
    </div>
  )
}
